import FormikInput from 'components/formikFields/input';
import {Form, Formik} from 'formik';
import {schema} from './utilities/validationSchema';
import useSetAuctionOffer from './hooks/useSetAuctionOffer';
import {useParams} from 'react-router-dom';

const OfferForm = ({setIsOpen, price, app}: IOfferFormProps) => {
  const params = useParams();
  const {isLoading, mutate} = useSetAuctionOffer(setIsOpen);
  return (
    <>
      <div className=" pt-2 px-3">
        <div className="flex justify-end">
          <span className="icon-close" onClick={() => setIsOpen(false)}></span>
        </div>
        <p>قیمت پیشنهادی خود را ارسال کنید.</p>
        <div className="flex mt-3 ">
          <span className="icon-information text-sm ml-1 text-blue-1"></span>
          <p className=" text-sm text-blue-1">
            قیمت پیشنهادی نمی‌تواند کمتر از قیمت پایه باشد.
          </p>
        </div>
        <Formik
          initialValues={{price: ''}}
          validationSchema={schema(price)}
          onSubmit={values => {
            const payload: IPostSuggestionAuction = {
              price: values.price,
              profile_type: app,
              post_guid: params.guid,
            };
            !isLoading && mutate(payload);
          }}
        >
          <Form>
            <div className="mt-6">
              <FormikInput
                label="قیمت"
                name="price"
                type="number"
                secondaryTitle="تومان"
              />
            </div>
            <div className="mt-8">
              <button
                type="submit"
                className=" w-full text-white bg-primary py-4 rounded-lg mb-6"
              >
                ارسال پیشنهاد
              </button>
            </div>
          </Form>
        </Formik>
      </div>
    </>
  );
};

export default OfferForm;
